import { DocumentEntryTypename } from '../../../../__generated__/chirp/com/hubspot/sales/documents/rpc/SalesDocumentIndexRpc';
// TODO(SalesDocumentsCHIRPMigration cleanup): delete this file along with DocumentSearchResultType;
// consumers should read DocumentEntry fields directly after filtering on __typename
export const mapDocumentEntry = entry => {
  var _entry$brandId, _entry$thumbnailUrl, _entry$createdBy$firs, _entry$createdBy, _entry$createdBy$last, _entry$createdBy2, _entry$createdBy$emai, _entry$createdBy3;
  if (entry.__typename !== DocumentEntryTypename) return null;
  return {
    contentId: entry.id,
    name: entry.name,
    documentId: String(entry.id),
    brandId: (_entry$brandId = entry.brandId) !== null && _entry$brandId !== void 0 ? _entry$brandId : null,
    // TODO: map isLegalConsentEnabled when included in DirectoryEntryIF
    legalConsentEnabled: null,
    metadata: {
      title: entry.name,
      thumbnailUrl: (_entry$thumbnailUrl = entry.thumbnailUrl) !== null && _entry$thumbnailUrl !== void 0 ? _entry$thumbnailUrl : '',
      user: {
        firstName: (_entry$createdBy$firs = (_entry$createdBy = entry.createdBy) === null || _entry$createdBy === void 0 ? void 0 : _entry$createdBy.firstName) !== null && _entry$createdBy$firs !== void 0 ? _entry$createdBy$firs : '',
        lastName: (_entry$createdBy$last = (_entry$createdBy2 = entry.createdBy) === null || _entry$createdBy2 === void 0 ? void 0 : _entry$createdBy2.lastName) !== null && _entry$createdBy$last !== void 0 ? _entry$createdBy$last : '',
        email: (_entry$createdBy$emai = (_entry$createdBy3 = entry.createdBy) === null || _entry$createdBy3 === void 0 ? void 0 : _entry$createdBy3.email) !== null && _entry$createdBy$emai !== void 0 ? _entry$createdBy$emai : ''
      }
    }
  };
};